export default "__VITE_ASSET__1ccf8c88__"